import { applyAnnouncedContentKeys } from '@/lib/multiScreen/reportContentKeysCache';
import { reportSyncChannel } from '@/lib/multiScreen/reportSyncChannel';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
/**
 * Mounted once at the app root. Applies content keys another window announced
 * (CONTENT_KEYS after populate-echo) to this window's report caches, whether
 * or not an editor is open here. Renders nothing.
 */
export function ReportContentKeysBridge() {
    const queryClient = useQueryClient();
    useEffect(() => reportSyncChannel.subscribeContentKeys((reportKey, patch) => applyAnnouncedContentKeys(queryClient, reportKey, patch)), [queryClient]);
    return null;
}
